const contact = (state) => `<section id='contact' class='wrapper pb-6'>
<h3 class='pt-6'>${state.titleContact}</h3>
<ul class='row mt-6 justify-content-center'>
  ${state.redesSociales
    .map(
      (social) => `
    <li>    
      <a href="${social.url}" target="_blank" rel="noopener">
        <i>${social.icon}
          <span>${social.titleSocial}</span> 
        </i>
      </a>
    </li>
    `
    )
    .join('')}

</ul>
<div class='d-flex justify-content-center'>
  <a href='${state.by.url}' class='mt-6' target="_blank" rel="noopener">${state.by.text
  }</a>
</div>
</section>`

export default contact
